<template>
    <UiHero id="sbHero" v-editable="blok" :blok="blok" />
</template>

<script setup>
defineProps({ blok: Object });
</script>

<style lang="postcss" scoped>
#sbHero {
    @apply items-start;

    background: linear-gradient(325deg, rgb(24 24 24), #023052);
    background-color: #023052;
    &.sbHero {
        @apply items-start;
    }

    :deep(.searchbox-steps) {
        @apply flex justify-center ml-[-1rem];
    }
}
</style>
